<template>
  <el-form-item
    :label="attrOption.label"
    :prop="attrOption.prop"
  >
    <el-select
      v-model="storeId"
      v-bind="attrOption"
    >
      <el-option
        v-for="item in attrOption.options.list"
        :key="'option' + item[attrOption.options.value]"
        :label="item[attrOption.options.label]"
        :value="item[attrOption.options.value]"
      >
      </el-option>
    </el-select>
    <el-button style="display: block"  type="text" @click="goToCreateStore">找不到门店？点击新增</el-button>
  </el-form-item>
</template>
<script>
export default {
  name: 'StoreItem',
  data() {
    return {
      tipFlag: false,
      // eslint-disable-next-line vue/no-unused-properties
      defaultOption: { filterable: true, clearable: true },
      attrOption: {},
    }
  },
  model: {
    prop: 'model',
    event: 'change',
  },
  props: {
    model: {
      type: [String, Number],
      default: '',
    },
  },
  watch: {
    $attrs: {
      handler(val) {
        this.attrOption = {
          ...this.defaultOption,
          ...val,
        }
      },
      deep: true,
    },
    'attrOption.options.list': {
      handler(val) {
        this.tipFlag = !val.length
      },
    },
    deep: true,
  },
  computed: {
    storeId: {
      set(val) {
        this.$emit('change', val)
      },
      get() {
        return this.model
      },
    },
    // eslint-disable-next-line vue/no-unused-properties
    tipContext() {
      return '若当前没有门店，请联系管理员在公司-门店管理模块添加'
    },
  },
  methods: {
    goToCreateStore() {
      this.$router.push('/companyNew/company/storeManage/add')
    },
  },
  created() {
    this.attrOption = {
      ...this.defaultOption,
      ...this.$attrs,
    }
  },
}
</script>

<style lang="scss" scoped>
.storeTips {
  display: block;
  font-size: 12px;
  line-height: 23px;
  color: #e6a23c;
}
</style>

